import { Link } from "react-router-dom";

export default function AdminShell({ currentUser, onSignOut, children }) {
  const handleSignOut = () => {
    onSignOut();
  };

  return (
    <div className="jw-admin">
      <header className="jw-admin__header">
        <Link to="/admin" className="jw-admin__brand">
          JOBUWIN Ops
        </Link>
        <div className="jw-admin__header-actions">
          {currentUser?.email ? (
            <span className="jw-admin__user">{currentUser.email}</span>
          ) : null}
          <button type="button" className="jw-admin__signout" onClick={() => void handleSignOut()}>
            Sign out
          </button>
        </div>
      </header>
      <main className="jw-admin__main">{children}</main>
    </div>
  );
}
